import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CaseDetailComponent } from '../case-detail.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-add-comment-dialog',
  standalone: true,
  imports: [ 
      MatFormFieldModule,
      MatInputModule,
      MatDividerModule,
      MatButtonModule,
      MatDialogModule,
      FormsModule
  ],
  templateUrl: './add-comment-dialog.component.html',
  styleUrl: './add-comment-dialog.component.scss'
})
export class AddCommentDialogComponent {
  comment: string | undefined;
  constructor(
    private readonly dialogRef: MatDialogRef<CaseDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  submit() {
    this.dialogRef.close(this.comment);
  }
  cancel() {
    this.dialogRef.close(false);
  }
}
